import { RebaseTranslations } from "@rebasepro/cms-types";

export const hi: RebaseTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "सहेजें",
    create: "बनाएं",
    create_copy: "प्रतिलिपि बनाएं",
    save_and_close: "सहेजें और बंद करें",
    create_copy_and_close: "प्रतिलिपि बनाएं और बंद करें",
    create_and_close: "बनाएं और बंद करें",
    discard: "रद्द करें (Discard)",
    clear: "साफ़ करें",
    cancel: "रद्द करें (Cancel)",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "संपादित करें",
    copy: "कॉपी करें",
    delete: "हटाएं",
    delete_not_allowed: "आपने कम से कम एक ऐसी इकाई चुनी है जिसे आप हटा नहीं सकते",
    edit_entity: "संपादित करें",
    back_to_detail: "विवरण पर वापस जाएँ",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "हटाएं?",
    delete_confirmation_body: "इससे इकाई (entity) हटा दी जाएगी। क्या आप सुनिश्चित हैं?",
    delete_multiple_confirmation_body: "इससे चयनित इकाइयां (entities) हटा दी जाएंगी। क्या आप सुनिश्चित हैं?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "सहेजे नहीं गए परिवर्तन",
    unsaved_changes_body: "आपके पास सहेजे नहीं गए परिवर्तन हैं। क्या आप उन्हें रद्द करना चाहते हैं?",
    discard_changes: "परिवर्तन रद्द करें",
    keep_editing: "संपादन जारी रखें",
    clear_form: "फ़ॉर्म साफ़ करें?",
    discard_changes_confirmation: "सभी सहेजे नहीं गए परिवर्तन खो जाएँगे। इसे पूर्ववत नहीं किया जा सकता।",
    clear_form_confirmation: "सभी दर्ज किए गए मान साफ़ कर दिए जाएँगे। इसे पूर्ववत नहीं किया जा सकता।",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "खोजें",
    find_by_id: "ID द्वारा खोजें",
    find_entity_by_id: "ID द्वारा इकाई खोजें",
    filter: "फ़िल्टर",
    filters: "फ़िल्टर",
    records_in_view: "इस दृश्य में रिकॉर्ड",
    clear_filter: "फ़िल्टर साफ़ करें",
    clear_filter_sort: "फ़िल्टर/सॉर्ट साफ़ करें",
    clear_sort: "सॉर्ट साफ़ करें",
    sort: "क्रमबद्ध करें",
    sort_by: "इसके अनुसार क्रमबद्ध करें",
    sort_then_by: "फिर इसके अनुसार",
    sort_ascending: "आरोही क्रम में लगाएँ",
    sort_descending: "अवरोही क्रम में लगाएँ",
    sort_remove: "क्रम हटाएँ",
    sort_move_up: "इस कुंजी को अधिक महत्व दें",
    sort_move_down: "इस कुंजी को कम महत्व दें",
    sort_remove_key: "यह क्रम कुंजी हटाएँ",
    sort_key_position: "क्रम कुंजी {{position}}",
    sort_shift_click_hint: "वर्तमान क्रम के नीचे कॉलम जोड़ने के लिए Shift+क्लिक करें",
    save_entity_before_subcollections: "अतिरिक्त संग्रह जोड़ने से पहले आपको एंटिटी सहेजनी होगी",
    clear_all: "सभी साफ़ करें",
    no_items: "कोई आइटम नहीं",
    no_entries_found: "कोई प्रविष्टि नहीं मिली",
    all_entries_loaded: "सभी {{count}} प्रविष्टियाँ लोड हो गईं",
    create_your_first_entry: "अपनी पहली प्रविष्टि बनाएं",
    no_results_filter_sort: "लागू किए गए फ़िल्टर/सॉर्ट के साथ कोई परिणाम नहीं",
    no_results_search: "\"{{search}}\" के लिए कोई परिणाम नहीं मिला",
    add: "जोड़ें",
    remove: "हटाएं",
    multiple_entities: "एकाधिक इकाइयां",
    unsaved_changes: "आपके पास {{collectionName}} में सहेजे नहीं गए परिवर्तन हैं।",
    so_empty: "इतना खाली...",
    no_results: "लागू किए गए फ़िल्टर/सॉर्ट के साथ कोई परिणाम नहीं",
    refresh_data: "डेटा रीफ़्रेश करें",
    dark_mode: "डार्क",
    light_mode: "लाइट",
    system_mode: "सिस्टम",
    join_newsletter: "न्यूज़लेटर से जुड़ें, कोई स्पैम नहीं",
    ok: "ठीक है",
    save_collection_config: "संग्रह संरचना सहेजें",
    search_for_more_icons: "और आइकन खोजें…",
    ai_modified: "AI द्वारा संशोधित",
    size_label: "आकार",
    group_by: "इसके द्वारा समूहित करें",
    initialize_kanban_order: "कानबन क्रम प्रारंभ करें",
    copy_id: "ID कॉपी करें",
    add_specific: "{{name}} जोड़ें",
    add_named: "\"{{name}}\" जोड़ें",
    select_specific: "विशिष्ट {{name}} चुनें",
    select_from: "{{name}} से चुनें",
    done: "हो गया",
    log_out: "लॉग आउट",
    column_cannot_be_edited: "इस कॉलम को सीधे संपादित नहीं किया जा सकता",
    close: "बंद करें",
    hide_list: "सूची छिपाएँ",
    show_list: "सूची दिखाएँ",
    unsaved_local_changes: "सहेजे नहीं गए स्थानीय परिवर्तन",
    unsaved_local_changes_description: "इस दस्तावेज़ को स्थानीय स्तर पर संपादित किया गया था और इसमें सहेजे नहीं गए परिवर्तन हैं। यदि आप इन्हें लागू नहीं करते हैं तो ये स्थानीय परिवर्तन खो जाएंगे।",
    preview_changes: "परिवर्तनों का पूर्वावलोकन करें",
    apply_changes: "परिवर्तन लागू करें",
    discard_local_changes: "स्थानीय परिवर्तन रद्द करें",
    preview_local_changes: "स्थानीय परिवर्तनों का पूर्वावलोकन करें",
    preview_local_changes_description: "ये वे स्थानीय परिवर्तन हैं जिन्हें फॉर्म पर लागू किया जाएगा।",
    type: "प्रकार",
    string: "स्ट्रिंग",
    number: "नंबर",
    boolean: "बूलियन",
    date: "दिनांक",
    map: "मैप",
    array: "ऐरे",
    arrays_of_arrays_not_supported: "ऐरे के ऐरे समर्थित नहीं हैं।",
    data_type_not_supported: "डेटा प्रकार {{dataType}} अभी समर्थित नहीं है",
    passkey_error_unsupported: "आपका डिवाइस या ब्राउज़र पासकी का समर्थन नहीं करता है।",

    // ─── Entity form feedback ─────────────────────────────────────
    saved_correctly: "सफलतापूर्वक सहेजा गया",
    error_before_saving: "डेटा तैयार करने में त्रुटि",
    error_after_saving: "सहेजने के बाद की प्रक्रिया में त्रुटि",
    error_saving_entity: "प्रविष्टि सहेजने में त्रुटि",
    entity_does_not_exist: "यह प्रविष्टि डेटाबेस में मौजूद नहीं है",
    form_modified: "इस फ़ॉर्म में बदलाव किए गए हैं",
    form_in_sync: "वर्तमान फ़ॉर्म डेटाबेस के साथ सिंक में है",
    fix_errors_before_saving: "सहेजने से पहले हाइलाइट की गई त्रुटियों को ठीक करें",

    admin: "एडमिन",
    home: "होम",
    this_form_has_errors: "इस फॉर्म में त्रुटियाँ हैं",
    error_loading_navigation: "नेविगेशन लोड करने में त्रुटि",
    error_loading_auth: "प्रमाणीकरण लोड करने में त्रुटि",
    this_form_has_been_modified: "इस फॉर्म को संशोधित किया गया है",
    current_form_in_sync: "वर्तमान फॉर्म डेटाबेस के साथ सिंक में है",
    open_in_console: "कंसोल में खोलें",
    collection_does_not_exist: "निर्दिष्ट संग्रह मौजूद नहीं है। कंसोल चेक करें",
    unexpected_value: "अप्रत्याशित मान",
    unexpected_value_click_to_edit: "अप्रत्याशित मान। संपादित करने के लिए क्लिक करें",
    unexpected_reference_value: "अप्रत्याशित संदर्भ मान। संपादित करने के लिए क्लिक करें",
    copy_url_to_clipboard: "क्लिपबोर्ड पर URL कॉपी करें",
    open_image_in_new_tab: "नई टैब में छवि खोलें",
    reference_not_set: "संदर्भ सेट नहीं है",
    reference_does_not_exist: "संदर्भ मौजूद नहीं है",
    entity_not_found: "इकाई नहीं मिली",
    entity_not_found_body: "यह रिकॉर्ड मौजूद नहीं है, या पंक्ति-स्तरीय सुरक्षा के कारण आपसे छिपा हो सकता है।",
    back_to_collection: "{{name}} पर वापस जाएँ",
    file_not_found: "फ़ाइल नहीं मिली",
    unsaved_changes_in_entity: "आपके पास इस इकाई में सहेजे नहीं गए परिवर्तन हैं।",
    delete_this_role: "यह भूमिका हटाएं",
    no_roles_yet: "आपके पास अभी तक कोई भूमिका नहीं है।",
    create_default_roles: "डिफ़ॉल्ट भूमिकाएँ बनाएँ",
    delete_role_confirmation: "क्या आप वाकई इस भूमिका को हटाना चाहते हैं?",
    delete_this_user: "इस उपयोगकर्ता को हटाएं",
    no_users_yet: "अभी तक कोई उपयोगकर्ता नहीं है",
    add_logged_user_as_admin: "लॉग इन उपयोगकर्ता को एडमिन के रूप में जोड़ें",
    add_current_user_as_admin: "वर्तमान उपयोगकर्ता को एडमिन के रूप में जोड़ें",
    create_default_roles_and_add_admin: "डिफ़ॉल्ट भूमिकाएँ बनाएं और वर्तमान उपयोगकर्ता को एडमिन के रूप में जोड़ें",
    delete_user_confirmation: "क्या आप वाकई इस उपयोगकर्ता को हटाना चाहते हैं?",
    create_your_users_and_roles: "अपने उपयोगकर्ता और भूमिकाएँ बनाएँ",
    no_users_or_roles_defined: "आपके पास कोई उपयोगकर्ता या भूमिका परिभाषित नहीं है। आप डिफ़ॉल्ट भूमिकाएँ बना सकते हैं और वर्तमान उपयोगकर्ता को एडमिन के रूप में जोड़ सकते हैं।",
    save_before_changing_schema: "स्कीमा बदलने से पहले आपको दस्तावेज़ सहेजना होगा",
    edit_schema_for_this_form: "इस फॉर्म के लिए स्कीमा संपादित करें",
    no_permissions_to_edit_collection: "आपके पास इस संग्रह को संपादित करने की अनुमति नहीं है",
    browser_does_not_support_audio: "आपका ब्राउज़र ऑडियो तत्व का समर्थन नहीं करता है।",
    user_not_found: "उपयोगकर्ता नहीं मिला: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "चयनित हटाएं",
    cannot_delete_selected: "आपने कम से कम एक इकाई का चयन किया है जिसे आप हटा नहीं सकते",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "जोड़ें",
    add_on_top: "शीर्ष पर जोड़ें",
    add_below: "नीचे जोड़ें",
    add_to_field: "{{fieldName}} में जोड़ें",
    value: "मान",
    key: "कुंजी",
    drag_drop_multiple: "कुछ फ़ाइलों को यहां खींचें और छोड़ें, या फ़ाइलों का चयन करने के लिए क्लिक करें। पुन: क्रमबद्ध करने के लिए खींचें।",
    drag_drop_single: "किसी फ़ाइल को यहां खींचें और छोड़ें, या किसी एक का चयन करने के लिए क्लिक करें",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "मेनू खोलें",
    close_drawer: "ड्रॉअर बंद करें",
    navigation_drawer: "नेविगेशन ड्रॉअर",
    collapse: "संक्षिप्त करें",
    expand: "विस्तार करें",
    change_language: "भाषा बदलें",
    toggle_theme: "थीम बदलें",
    user_menu: "उपयोगकर्ता मेनू",

    // ─── Error states ─────────────────────────────────────────────
    error: "त्रुटि",
    error_loading_data: "डेटा लोड नहीं हो सका",
    error_check_server_logs: "विस्तृत जानकारी के लिए सर्वर लॉग देखें।",
    error_technical_details: "तकनीकी विवरण",
    error_uploading_file: "फ़ाइल अपलोड करने में त्रुटि",
    error_deleting: "हटाने में त्रुटि",
    error_before_delete: "हटाने से पहले त्रुटि",
    error_updating_asset: "एसेट अपडेट करने में त्रुटि",
    error_deleting_asset: "एसेट हटाने में त्रुटि",
    error_firestore_index: "इस क्वेरी के लिए Firestore इंडेक्स आवश्यक है।",
    create_index: "इंडेक्स बनाएं",
    value_is_not_reference: "मान एक संदर्भ नहीं है।",
    click_to_edit: "संपादित करने के लिए क्लिक करें",
    data_is_not_array_of_references: "डेटा संदर्भों का ऐरे नहीं है",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "लोड हो रहा है",
    local_changes_applied: "स्थानीय परिवर्तन फॉर्म पर लागू किए गए",
    local_changes_discarded: "स्थानीय परिवर्तन रद्द किए गए",
    are_you_sure_leave: "क्या आप वाकई इस पृष्ठ को छोड़ना चाहते हैं?",
    see_console_details: "अधिक विवरण के लिए कंसोल देखें।",
    drop_here_create_group: "नया समूह बनाने के लिए यहां छोड़ें",
    filter_for_null_values: "रिक्त (नल्ल) मानों के लिए फ़िल्टर करें",
    value_updated_elsewhere: "इस मान को कहीं और अपडेट किया गया है",
    add_property: "विशेषता (प्रॉपर्टी) जोड़ें",
    edit_name: "{{name}} संपादित करें",
    this_entity_not_exist: "यह इकाई डेटाबेस में मौजूद नहीं है",
    internal_error: "आंतरिक त्रुटि (Internal ERROR)",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "समूह का नाम बदलें",
    group_name_label: "समूह का नाम",
    group_name_empty_error: "समूह का नाम खाली नहीं हो सकता।",
    group_name_exists_error: "यह समूह नाम पहले से मौजूद है।",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "संग्रह खोजें",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "दृश्य",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "अतिरिक्त संग्रह जोड़ने से पहले आपको अपनी इकाई को सहेजना होगा",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "पृष्ठ नहीं मिला",
    page_not_found_body: "यह पृष्ठ मौजूद नहीं है या आपके पास इस तक पहुंच नहीं हो सकती है",
    back_to_home: "होम पर वापस जाएँ",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "डिफ़ॉल्ट संग्रह दृश्य",
    table_view: "तालिका",
    cards_view: "कार्ड्स",
    kanban_view: "कानबन",
    choose_how_entities_displayed_default: "चुनें कि डिफ़ॉल्ट रूप से इकाइयां कैसे प्रदर्शित होनी चाहिए",

    document_view: "दस्तावेज़ दृश्य",
    side_panel: "साइड पैनल",
    full_screen: "पूरी स्क्रीन",
    should_documents_opened_full_screen: "क्या दस्तावेज़ों को फ़ुल स्क्रीन में या इनलाइन साइड डायलॉग में खोला जाना चाहिए",

    select_custom_view: "कस्टम दृश्य चुनें",
    no_custom_views_defined: "कोई कस्टम दृश्य परिभाषित नहीं है। इस डायलॉग का उपयोग करने से पहले कस्टमाइज़ेशन सेटिंग्स में अपने कस्टम दृश्य परिभाषित करें।",

    select_custom_action: "कस्टम कार्रवाई चुनें",
    no_custom_actions_defined: "कोई कस्टम कार्रवाई परिभाषित नहीं है। इस डायलॉग का उपयोग करने से पहले कस्टमाइज़ेशन सेटिंग्स में अपनी कस्टम कार्रवाइयाँ परिभाषित करें।",

    no_collections_found: "कोई संग्रह नहीं मिला",
    start_building_collections: "Rebase में आसानी से संग्रह बनाना शुरू करें। उन्हें अपने मौजूदा डेटाबेस डेटा पर मैप करें, फ़ाइलों से आयात करें या हमारे टेम्प्लेट का उपयोग करें।",
    create_first_collection: "अपना पहला संग्रह बनाएं",
    define_collections_programmatically: "आप संग्रहों को प्रोग्रामेटिक रूप से भी परिभाषित कर सकते हैं।",
    edit_collection: "संग्रह संपादित करें",
    no_permissions_edit_collection: "आपके पास इस संग्रह को संपादित करने की अनुमति नहीं है",
    no_permissions_create_collection: "आपके पास संग्रह बनाने की अनुमति नहीं है",
    create_collection: "संग्रह बनाएं",
    update_collection: "संग्रह अपडेट करें",

    new_collection: "नया संग्रह",
    add_new_collection: "नया संग्रह जोड़ें",
    collection_with_name: "{{name}} संग्रह",
    change_icon: "आइकन बदलें",
    is_subcollection_of: "यह इसका उपसंग्रह (subcollection) है",
    name: "नाम",
    collection_name_description: "इस संग्रह का नाम, आमतौर पर एक बहुवचन नाम (जैसे उत्पाद)",
    path: "पथ (Path)",
    relative_path_to_parent: "मूल (parent) का सापेक्ष पथ (मूल पथ को शामिल करने की आवश्यकता नहीं है)",
    path_in_database: "वह पथ जिसमें यह संग्रह संग्रहीत है, डेटाबेस में",
    singular_name: "एकवचन नाम",
    singular_name_description: "वैकल्पिक रूप से अपनी इकाइयों के लिए एकवचन नाम परिभाषित करें",
    description: "विवरण",
    description_of_collection: "संग्रह का विवरण, आप मार्कडाउन का उपयोग कर सकते हैं",
    collection_id: "संग्रह ID",
    collection_id_description: "यह ID इस संग्रह की पहचान करता है। आम तौर पर पथ के समान।",
    collection_group: "संग्रह समूह",
    collection_group_description: "एक संग्रह समूह में एक ही पथ वाले सभी संग्रह होते हैं। यह आपको एक साथ कई संग्रहों पर क्वेरी करने की अनुमति देता है।",
    advanced_settings: "उन्नत सेटिंग्स",
    doc_history_global: "दस्तावेज़ इतिहास संशोधन सक्षम (यदि विश्व स्तर पर सक्षम हैं)",
    doc_history_enabled: "दस्तावेज़ इतिहास संशोधन सक्षम",
    doc_history_not_enabled: "दस्तावेज़ इतिहास संशोधन सक्षम नहीं",
    doc_history_description: "सक्षम होने पर, इस संग्रह के प्रत्येक दस्तावेज़ में परिवर्तनों का इतिहास होगा। यह ऑडिटिंग उद्देश्यों के लिए उपयोगी है। डेटा आपके डेटाबेस में दस्तावेज़ के एक उपसंग्रह में संग्रहीत होता है, जिसे __history कहा जाता है।",
    document_id_generation: "दस्तावेज़ ID जनरेशन",
    code_defined: "कोड परिभाषित",
    users_must_define_id: "उपयोगकर्ताओं को एक ID परिभाषित करनी होगी",
    users_can_define_id: "उपयोगकर्ता एक ID परिभाषित कर सकते हैं, लेकिन इसकी आवश्यकता नहीं है",
    doc_id_auto_generated: "दस्तावेज़ ID स्वचालित रूप से उत्पन्न होती है",
    config_doc_id_generation: "नई इकाइयां बनाते समय दस्तावेज़ ID कैसे उत्पन्न होती हैं, इसे कॉन्फ़िगर करें।",
    enable_text_search: "इस संग्रह के लिए पाठ खोज (text search) सक्षम करें",
    text_search_description: "इस संग्रह के लिए पाठ खोज की अनुमति दें। यदि आपने पाठ खोज प्रतिनिधि निर्दिष्ट नहीं किया है, तो यह अंतर्निहित स्थानीय पाठ खोज का उपयोग करेगा। बड़े संग्रहों के लिए इसकी अनुशंसा नहीं की जाती है, क्योंकि इससे प्रदर्शन और लागत संबंधी समस्याएं हो सकती हैं।",
    database_id: "डेटाबेस ID",
    default_text: "(डिफ़ॉल्ट)",

    custom_actions: "कस्टम कार्रवाइयां",
    more_info: "अतिरिक्त जानकारी",
    define_custom_actions_cli: "CLI के साथ अपलोड करके अपनी स्वयं की कस्टम कार्रवाइयां परिभाषित करें।",
    action_defined_in_code: "यह क्रिया कोड में कुंजी (key) के साथ परिभाषित की गई है",
    add_custom_entity_action: "कस्टम इकाई कार्रवाई जोड़ें",
    remove_this_action: "यह क्रिया हटाएँ?",
    remove_action_warning: "यह कोई डेटा नहीं हटाएगा, केवल एडमिन पैनल में कार्रवाई को हटाएगा",

    subcollections_of: "के उपसंग्रह",
    add_subcollection: "उपसंग्रह जोड़ें",
    custom_views: "कस्टम दृश्य",
    define_custom_views_cli: "CLI के साथ अपलोड करके अपने स्वयं के कस्टम दृश्य परिभाषित करें।",
    view_defined_in_code: "यह दृश्य कोड में कुंजी (key) के साथ परिभाषित किया गया है",
    add_custom_entity_view: "कस्टम इकाई दृश्य जोड़ें",
    delete_this_subcollection: "इस उपसंग्रह को हटाएं?",
    remove_collection_warning: "यह कोई डेटा नहीं हटाएगा, केवल एडमिन पैनल में संग्रह को हटाएगा",
    remove_this_view: "यह दृश्य हटाएँ?",
    remove_view_warning: "यह कोई डेटा नहीं हटाएगा, केवल एडमिन पैनल में दृश्य को हटाएगा",

    no_collection_selected: "कोई संग्रह नहीं चुना गया",
    code_for_collection: "संग्रह के लिए कोड",
    use_config_define_json: "संग्रह को JSON प्रारूप में परिभाषित करने के लिए इस कॉन्फ़िगरेशन का उपयोग करें।",
    customise_collection_code: "यदि आप कोड में संग्रह को अनुकूलित करना चाहते हैं, तो आप इस संग्रह कोड को अपने एडमिन ऐप कॉन्फ़िगरेशन में जोड़ सकते हैं।",
    copied: "कॉपी किया गया",

    property_cant_be_edited: "इस विशेषता को संपादित नहीं किया जा सकता",
    property_not_editable_description: "आपके पास इसे संपादित करने की अनुमति नहीं हो सकती है या इसे कोड में परिभाषित किया गया है और इसे संशोधित नहीं किया जा सकता।",
    delete_this_property: "यह विशेषता हटाएँ?",
    delete_property_warning: "यह कोई डेटा नहीं हटाएगा, केवल संग्रह को संशोधित करेगा।",
    error_must_specify_id: "आपको फ़ील्ड के लिए एक id निर्दिष्ट करना होगा",
    error_id_format: "id में केवल अक्षर, संख्याएं और अंडरस्कोर (_) हो सकते हैं, और यह किसी संख्या से शुरू नहीं हो सकता",
    error_id_already_exists: "इस ID के साथ पहले से ही एक और फ़ील्ड मौजूद है",
    error_must_specify_title: "आपको फ़ील्ड के लिए एक शीर्षक निर्दिष्ट करना होगा",
    custom_or_other: "कस्टम/अन्य",
    select_property_widget: "एक प्रॉपर्टी विजेट का चयन करें",
    error_changing_data_type: "यह विजेट प्रारंभ में चयनित विजेट की तुलना में एक अलग डेटा प्रकार का उपयोग करता है। यह मौजूदा डेटा के साथ त्रुटियों का कारण बन सकता है।",
    required: "आवश्यक",

    enum_form_dialog: "Enum फॉर्म डायलॉग",
    imported_data_preview: "आयात किए गए डेटा का पूर्वावलोकन",
    entities_with_same_id_overwritten: "समान id वाली इकाइयों को अधिलेखित (overwritten) किया जाएगा",
    collection_editor: "संग्रह संपादक",
    properties_in_this_group: "इस समूह में विशेषताएं",
    data_property_mapping: "डेटा संपत्ति मानचित्रण (मॅपिंग)",
    property_edit_view: "प्रॉपर्टी संपादन दृश्य",
    all_of_these: "ये सभी",
    any_of_these: "इनमें से कोई भी",

    only_admins_edit_roles: "केवल व्यवस्थापक (Admins) ही भूमिकाएँ संपादित कर सकते हैं",
    error_user_not_found: "उपयोगकर्ता नहीं मिला",
    all_roles: "सभी भूमिकाएँ",
    role: "भूमिका",
    name_of_this_role: "इस भूमिका का नाम",
    id_of_this_role: "इस भूमिका की ID",
    create_entities: "इकाइयाँ बनाएँ",
    read_entities: "इकाइयाँ पढ़ें",
    update_entities: "इकाइयाँ अपडेट करें",
    delete_entities: "इकाइयाँ हटाएँ",
    all_collections: "सभी संग्रह",
    create_entities_in_collections: "संग्रहों में इकाइयाँ बनाएँ",
    access_all_data_in_every_collection: "हर संग्रह में सभी डेटा तक पहुँचें",
    update_data_in_any_collection: "किसी भी संग्रह में डेटा अपडेट करें",
    delete_data_in_any_collection: "किसी भी संग्रह में डेटा हटाएँ",
    allow_all_permissions_in_this_collections: "इन संग्रहों में सभी अनुमतियों की अनुमति दें",
    all: "सभी",
    customise_permissions_description: "आप उन अनुमतियों को अनुकूलित कर सकते हैं जो इस भूमिका से संबंधित उपयोगकर्ता प्रत्येक संग्रह की इकाइयों में कर सकते हैं",
    create_collections: "संग्रह बनाएँ",
    yes: "हाँ",
    no: "नहीं",
    can_user_create_collections: "क्या उपयोगकर्ता संग्रह बना सकता है",
    edit_collections: "संग्रह संपादित करें",
    only_own_collections: "केवल उसकी/उसकी अपनी",
    own: "अपनी",
    can_user_edit_collections: "क्या उपयोगकर्ता संग्रह संपादित कर सकता है",
    delete_collections: "संग्रह हटाएँ",
    can_user_delete_collections: "क्या उपयोगकर्ता संग्रह हटा सकता है",
    error_saving_role: "इस भूमिका को सहेजने में कोई त्रुटि हुई",
    create_role: "भूमिका बनाएँ",
    update: "अपडेट करें",

    only_admins_change_roles: "केवल व्यवस्थापक ही भूमिकाएँ बदल सकते हैं",
    must_be_at_least_one_admin: "कम से कम एक एडमिन होना चाहिए",
    logged_user_not_found: "लॉग इन उपयोगकर्ता नहीं मिला",
    user: "उपयोगकर्ता (User)",
    user_id: "उपयोगकर्ता ID",
    name_of_this_user: "इस उपयोगकर्ता का नाम",
    email_of_this_user: "इस उपयोगकर्ता का ईमेल",
    roles: "भूमिकाएँ",
    create_user: "उपयोगकर्ता बनाएँ",

    users: "उपयोगकर्ता (Users)",
    add_user: "उपयोगकर्ता जोड़ें",
    add_role: "भूमिका जोड़ें",
    is_admin: "एडमिन है",
    default_permissions: "डिफ़ॉल्ट अनुमतियाँ",
    created_on: "इस दिन बनाया गया",
    email: "ईमेल",
    id: "ID",
    read: "पढ़ें",

    column_in_file: "फ़ाइल में कॉलम",
    map_to_property: "प्रॉपर्टी में मैप करें",
    default_values: "डिफ़ॉल्ट मान",
    default_values_description: "आप अनमैप किए गए कॉलम और खाली मानों के लिए एक डिफ़ॉल्ट मान का चयन कर सकते हैं:",
    property: "विशेषता (Property)",
    default_value: "डिफ़ॉल्ट मान",
    autogenerate_id: "ID स्वतः उत्पन्न करें",
    id_column_description: "कॉलम जिसका उपयोग प्रत्येक दस्तावेज़ के लिए ID के रूप में किया जाएगा",
    do_not_set_value: "मान सेट न करें",
    set_value_to_true: "मान को true पर सेट करें",
    set_value_to_false: "मान को false पर सेट करें",
    drag_and_drop_file: "फ़ाइल को यहां खींचें और छोड़ें या अपलोड करने के लिए क्लिक करें",
    error_saving_data: "डेटा सहेजने में त्रुटि",
    retry: "पुनः प्रयास करें",
    saving_data: "डेटा सहेजा जा रहा है",
    entities_saved: "इकाइयाँ सहेजी गईं",
    do_not_close_tab: "इस टैब को बंद न करें अन्यथा आयात बाधित हो जाएगा",
    import: "आयात (Import)",
    import_data: "डेटा आयात करें",
    upload_file_description: "CSV, Excel या JSON फ़ाइल अपलोड करें और इसे अपने मौजूदा स्कीमा में मैप करें",
    back: "पीछे",
    next: "अगला",
    save_data: "डेटा सहेजें",
    use_column_as_id: "इस कॉलम को ID के रूप में उपयोग करें",
    do_not_import_property: "इस विशेषता को आयात न करें",
    entities_will_be_overwritten: "समान ID वाली इकाइयों को अधिलेखित (overwritten) किया जाएगा",
    data_imported_successfully: "डेटा सफलतापूर्वक आयात किया गया",
    export: "निर्यात (Export)",
    export_data: "डेटा निर्यात करें",
    download_table_csv: "इस तालिका की सामग्री को CSV के रूप में डाउनलोड करें",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "टाइमस्टैम्प के रूप में तिथियां",
    dates_as_strings: "स्ट्रिंग्स के रूप में तिथियां",
    flatten_arrays: "ऐरे को फ़्लैट करें",
    download: "डाउनलोड",
    large_number_of_documents: "इस संग्रह में बड़ी संख्या में दस्तावेज़ हैं ({{count}})।",
    too_many_documents_to_export: "इस संग्रह में इतने दस्तावेज़ ({{count}}) हैं कि ब्राउज़र उन्हें एक ही फ़ाइल में निर्यात नहीं कर सकता (सीमा {{limit}})। निर्यात से पहले इसे फ़िल्टर करें।",
    include_undefined_values: "अपरिभाषित (undefined) मान शामिल करें",
    submit: "सबमिट करें",

    no_filterable_properties: "कोई फ़िल्टर करने योग्य गुण उपलब्ध नहीं हैं",
    apply_filters: "फ़िल्टर लागू करें",

    // ─── Filter Presets ──────────────────────────────────────────
    filter_presets: "प्रीसेट",
    filter_preset_apply: "प्रीसेट लागू करें",
    filter_preset_active: "सक्रिय: {{label}}",

    list: "सूची",
    table_view_mode: "तालिका",
    cards: "कार्ड",
    board: "बोर्ड",
    initialize_kanban_order_desc: "यह उन सभी आइटम को अनुक्रमिक क्रम मान निर्दिष्ट करेगा जिनके पास एक नहीं है। आइटम प्रत्येक कॉलम के भीतर अपना वर्तमान क्रम बनाए रखेंगे।",
    kanban_view_not_available: "कानबन दृश्य उपलब्ध नहीं है",
    kanban_view_requires_enum: "कानबन दृश्य के लिए इकाइयों को कॉलम में समूहीकृत करने के लिए एनम (Enum) मानों वाली एक स्ट्रिंग संपत्ति की आवश्यकता होती है। कृपया इस दृश्य का उपयोग करने के लिए अपने संग्रह स्कीमा में एक Enum संपत्ति जोड़ें।",
    no_enum_values_configured: "प्रॉपर्टी \"{{property}}\" के लिए कोई एनम मान कॉन्फ़िगर नहीं किया गया है",
    items_need_backfill: "कुछ आइटम के क्रम मान नहीं होते हैं। खींचें-और-छोड़ें (Drag-and-drop) पुनर्रचना को सक्षम करने के लिए प्रारंभ करें।",
    kanban_order_not_configured: "खींचें-और-छोड़ें क्रमबद्धता कॉन्फ़िगर नहीं है। कार्ड की स्थिति बनाए रखने के लिए संग्रह सेटिंग्स में एक क्रम गुण सेट करें।",
    initialize: "प्रारंभ करें",
    confirm_multiple_delete: "एकाधिक विलोपन की पुष्टि करें?",
    delete_entity_confirm_title: "क्या आप इस {{entityName}} को हटाना चाहेंगे?",
    add_existing: "मौजूदा जोड़ें",
    unlink_entity_confirm_title: "इस {{entityName}} को इस रिकॉर्ड से हटाएँ?",
    unlink_entity_confirm_body: "यह {{collectionName}} में बना रहेगा और अन्य रिकॉर्ड के लिए उपलब्ध रहेगा।",
    confirm_multiple_unlink: "क्या इन्हें इस रिकॉर्ड से हटाना है?",
    no_filter: "कोई फ़िल्टर नहीं",
    is_true: "सत्य है",
    is_false: "असत्य है",
    error_uploading_file_size: "फ़ाइल अपलोड करने में त्रुटि: फ़ाइल {{maxSize}} बाइट से बड़ी है",
    error_uploading_file_type: "फ़ाइल अपलोड करने में त्रुटि: यह फ़ाइल प्रकार समर्थित नहीं है",
    drag_drop_files: "फ़ाइलें यहाँ खींचकर छोड़ें, या संपादित करने के लिए यहाँ क्लिक करें",
    drag_drop_file: "फ़ाइल यहाँ खींचकर छोड़ें, या संपादित करने के लिए यहाँ क्लिक करें",
    multiple_deleted: "कई हटाए गए",
    some_entities_deleted: "कुछ संस्थाएँ हटा दी गई हैं, लेकिन सभी नहीं",
    error_deleting_entities: "संस्थाओं को हटाने में त्रुटि",
    deleted: "हटाया गया",
    selection_options: "चयन विकल्प",
    selection_menu_all_loaded: "इस पृष्ठ पर सभी",
    selection_menu_all_matching: "सभी {{total}} {{collection}}",
    selection_menu_none: "कोई नहीं",
    selection_select_all_loaded: "लोड की गई पंक्तियाँ चुनें",
    selection_deselect_all: "सभी अचयनित करें",
    selection_reading_rows: "पंक्तियाँ पढ़ी जा रही हैं… {{total}} में से {{loaded}}",
    selection_reading_rows_unknown: "पंक्तियाँ पढ़ी जा रही हैं… अब तक {{loaded}}",
    selection_deleting_progress: "{{total}} में से {{completed}} हटाए गए",
    confirm_delete_selection: "क्या {{total}} {{collection}} हटाएँ?",
    confirm_delete_selection_unknown: "क्या वर्तमान फ़िल्टर से मेल खाने वाली सभी पंक्तियाँ हटाएँ?",
    confirm_delete_selection_body: "इसे पूर्ववत नहीं किया जा सकता। हर पंक्ति अलग-अलग हटाई जाती है, इसलिए इसमें कुछ समय लग सकता है।",

    export_selection_count: "{{total}} चयनित पंक्तियाँ {{format}} रूप में डाउनलोड करें",
    export_selection_all_matching: "वर्तमान फ़िल्टर से मेल खाने वाले सभी {{collection}} डाउनलोड करें",

    select_reference: "संदर्भ चुनें",
    select_references: "संदर्भ चुनें (एकाधिक)",
    account_settings: "खाता सेटिंग्स",
    profile: "Profile",
    security: "सुरक्षा",
    sessions: "Sessions",
    change_password: "पासवर्ड बदलें",
    current_password: "वर्तमान पासवर्ड",
    new_password: "नया पासवर्ड",
    confirm_password: "नया पासवर्ड की पुष्टि करें",
    password_changed: "पासवर्ड सफलतापूर्वक बदल गया। आपको लॉग आउट कर दिया जाएगा।",
    passwords_dont_match: "पासवर्ड मेल नहीं खाते",
    password_too_short: "पासवर्ड कम से कम 8 वर्णों का होना चाहिए",
    password_change_not_available: "बाहरी साइन-इन प्रदाता का उपयोग करने वाले खातों के लिए पासवर्ड बदलना उपलब्ध नहीं है।",
    changing_password: "बदला जा रहा है...",
    display_name: "प्रदर्शित नाम",
    photo_url: "फ़ोटो URL",
    save_profile: "प्रोफ़ाइल सहेजें",
    saving: "Saving...",
    no_active_sessions: "कोई सक्रिय सत्र नहीं मिला।",
    revoking: "Revoking...",
    revoke_all_sessions: "सभी सत्र रद्द करें",
    unknown_device: "अज्ञात डिवाइस",
    current: "Current",
    role_id: "भूमिका ID",
    role_name: "भूमिका का नाम",
    add_reference: "संदर्भ जोड़ें",
    add_reference_to: "{{name}} में संदर्भ जोड़ें",

    /** RolesView — table & permissions */
    role_deleted_successfully: "भूमिका सफलतापूर्वक हटाई गई",
    error_deleting_role: "भूमिका हटाने में त्रुटि",
    collection_permissions: "संग्रह की अनुमतियाँ",
    collection: "Collection",
    no_collections_configured: "कोई संग्रह कॉन्फ़िगर नहीं है",
    no_security_rules_defined: "कोई सुरक्षा नियम परिभाषित नहीं — सभी संक्रियाएँ अप्रतिबंधित हैं",
    no_rules: "कोई नियम नहीं",

    /** UsersView — snackbar */
    bootstrap_admin_success: "अब आप व्यवस्थापक हैं! रीफ़्रेश किया जा रहा है...",
    failed_to_bootstrap_admin: "व्यवस्थापक सेट नहीं किया जा सका",
    user_deleted_successfully: "उपयोगकर्ता सफलतापूर्वक हटाया गया",
    error_deleting_user: "उपयोगकर्ता हटाने में त्रुटि",
    user_created_successfully: "उपयोगकर्ता सफलतापूर्वक बनाया गया",
    invitation_sent: "{{email}} पर आमंत्रण ईमेल भेज दिया गया है। वे लिंक से अपना पासवर्ड सेट कर सकते हैं।",
    invitation_sent_title: "आमंत्रण भेजा गया",
    temporary_password: "अस्थायी पासवर्ड",
    temporary_password_description: "ईमेल कॉन्फ़िगर नहीं है। यह अस्थायी पासवर्ड उपयोगकर्ता को सुरक्षित रूप से दें। यह दोबारा नहीं दिखाया जाएगा।",
    temporary_password_email_failed_description: "ईमेल भेजा नहीं जा सका। यह अस्थायी पासवर्ड उपयोगकर्ता को सुरक्षित रूप से दें। यह दोबारा नहीं दिखाया जाएगा।",
    copy_password: "पासवर्ड कॉपी करें",
    password_copied: "पासवर्ड क्लिपबोर्ड पर कॉपी हो गया",

    /** UsersView — pagination & search */
    search_users: "उपयोगकर्ता खोजें",
    created: "बनाया गया",
    actions: "क्रियाएँ",
    no_users_found: "कोई उपयोगकर्ता नहीं मिला",
    reset_password: "पासवर्ड रीसेट करें",
    reset_password_success: "पासवर्ड सफलतापूर्वक रीसेट हो गया",
    reset_password_confirmation: "क्या आप वाकई इस उपयोगकर्ता का पासवर्ड रीसेट करना चाहते हैं?",
    reset_password_send_email: "पासवर्ड रीसेट ईमेल भेजें",
    reset_password_set_manually: "पासवर्ड मैन्युअल रूप से सेट करें",
    reset_password_set_manually_description: "पासवर्ड तुरंत बदल जाता है और कोई ईमेल नहीं भेजा जाता। इसे उपयोगकर्ता को सुरक्षित रूप से दें।",

    /** Permission-denied empty states */
    no_permission_to_view_users: "आपको उपयोगकर्ताओं को देखने की अनुमति नहीं है",
    no_permission_to_view_roles: "आपको भूमिकाओं को देखने की अनुमति नहीं है",
    no_permission_description: "यदि आपको इस अनुभाग तक पहुँच की आवश्यकता है तो किसी व्यवस्थापक से संपर्क करें।",
    error_resetting_password: "पासवर्ड रीसेट करने में त्रुटि",

    /** Editor table-bubble */
    add_row_before: "पहले पंक्ति जोड़ें",
    add_row_after: "बाद में पंक्ति जोड़ें",
    delete_row: "पंक्ति हटाएँ",
    add_column_before: "पहले स्तंभ जोड़ें",
    add_column_after: "बाद में स्तंभ जोड़ें",
    delete_column: "स्तंभ हटाएँ",
    delete_table: "तालिका हटाएँ",

    /** Editor image-bubble */
    alt_text: "वैकल्पिक पाठ",
    title: "Title",

    /** MapFieldBinding */
    a_property_of_this_map_has_error: "इस मानचित्र की एक प्रॉपर्टी में त्रुटि है",

    /** AI Collection Generator Popover */
    generate_collection_with_ai: "AI से संग्रह बनाएं",
    modify_collection_with_ai: "AI से संग्रह संशोधित करें",
    describe_collection_to_create: "वह संग्रह बताएं जिसे आप बनाना चाहते हैं।",
    describe_changes_to_make: "वे परिवर्तन बताएं जो आप इस संग्रह में करना चाहते हैं।",
    ai_placeholder_create: "उदा. नाम, मूल्य, विवरण और श्रेणी के साथ एक उत्पाद संग्रह बनाएं...",
    ai_placeholder_modify: "उदा. स्टोरेज के साथ एक थंबनेल छवि फ़ील्ड जोड़ें, मूल्य को आवश्यक बनाएं...",
    ai_assist: "AI सहायक",
    generating: "उत्पन्न हो रहा है...",

    /** Recently extracted strings for collection editor */
    this_is_subcollection_of: "यह इसका एक उपसंघ (subcollection) है",
    use_existing_paths_database: "अपने डेटाबेस में मौजूदा पथों में से एक का उपयोग करें:",
    describe_collection_ai: "AI को अपने संग्रह का वर्णन करें:",
    generate_with_ai: "AI के साथ जनरेट करें",
    create_from_json_config: "JSON कॉन्फ़िगरेशन से बनाएँ:",
    paste_json_config: "JSON कॉन्फ़िगरेशन पेस्ट करें",
    create_collection_from_file_formats: "फ़ाइल (csv, json, xls, xslx...) से एक संग्रह बनाएँ",
    select_template: "एक टेम्पलेट चुनें:",
    products: "उत्पाद",
    collection_products_subtitle: "छवियों, कीमतों और स्टॉक वाले उत्पादों का संग्रह",
    collection_users_subtitle: "ईमेल, नाम और भूमिकाओं वाले उपयोगकर्ताओं का एक संग्रह",
    blog_posts: "ब्लॉग पोस्ट",
    collection_blog_posts_subtitle: "छवियों, लेखकों और जटिल सामग्री के साथ ब्लॉग पोस्ट का एक संग्रह",
    pages: "पृष्ठ (Pages)",
    collection_pages_subtitle: "छवियों, लेखकों और जटिल सामग्री के साथ पृष्ठों का एक संग्रह",
    continue_from_scratch: "शुरुआत से जारी रखें",

    /** Admin views config */
    admin_users: "एडमिन पैनल उपयोगकर्ता",
    roles_menu: "भूमिकाएँ",
    project_settings: "परियोजना सेटिंग",

    by_signing_in_you_agree_to_our: "साइन इन करके आप हमारे नियमों और शर्तों से सहमत होते हैं",
    terms_and_conditions: "नियम और शर्तें",
    and_our: "और हमारी गोपनीयता नीति",
    privacy_policy: "गोपनीयता नीति",
    email_password: "ईमेल/पासवर्ड",
    sign_in_with_google: "Google से साइन इन करें",

    // --- Auth error messages ---
    auth_user_not_found: "उपयोगकर्ता नहीं मिला",
    auth_wrong_password: "गलत पासवर्ड। कृपया पुनः प्रयास करें।",
    auth_user_disabled: "उपयोगकर्ता अक्षम है। कृपया समर्थन से संपर्क करें।",
    auth_account_exists_with_different_credential: "विभिन्न साइन-इन विधि के साथ खाता मौजूद है",
    auth_email_already_in_use: "ईमेल पहले से ही उपयोग में है",
    auth_google_permissions_required: "अपने Google Cloud प्रोजेक्ट प्रबंधित करने के लिए आपको अतिरिक्त अनुमतियाँ देने की आवश्यकता है",
    auth_invalid_email_password: "कृपया ईमेल और पासवर्ड दोनों दर्ज करें",
    auth_enter_email_first: "कृपया पहले अपना ईमेल दर्ज करें",
    auth_password_reset_sent: "पासवर्ड रीसेट ईमेल भेजा गया",
    auth_sign_in_account: "अपने खाते में प्रवेश करें",
    auth_create_new_account: "एक नया अकाउंट बनाएँ",
    auth_password: "पासवर्ड",
    auth_reset_password: "पासवर्ड रीसेट करें",
    auth_new_user: "नया उपयोगकर्ता?",
    auth_have_account: "क्या आपके पास एक खाता है?",
    auth_sign_in: "साइन इन करें",
    auth_sign_up: "साइन अप करें",


    auto_setup_collections_button: "संग्रहों को स्वचालित रूप से सेट करें",
    auto_setup_collections_title: "संग्रहों की स्वचालित सेटअप",
    auto_setup_collections_desc: "अपने मौजूदा Firestore डेटा के आधार पर संग्रहों को स्वचालित रूप से सेट करें। Rebase को आपके लिए परफेक्ट एडमिन पैनल कॉन्फ़िगर करने दें।",
    this_can_take_a_minute: "इसमें एक मिनट लग सकता है",
    no_collections_found_to_setup: "सेट करने के लिए कोई संग्रह नहीं मिला",
    collections_have_been_setup: "संग्रहों को सेट कर दिया गया है",
    error_setting_up_collections: "संग्रह सेट करने में त्रुटि",

    // --- Home Suggestions ---

    admin_panel_ready_bring_data: "आपका पैनल तैयार है। अपना डेटा जोड़कर शुरू करें।",
    admin_panel_ready_get_started: "शुरू करें",
    auto_detect_collections: "संग्रहों को स्वचालित रूप से पहचानें",
    auto_detect_collections_desc: "Rebase आपके Firestore डेटा का विश्लेषण करेगा और आपके लिए संग्रहों को स्वचालित रूप से कॉन्फ़िगर करेगा",
    create_a_collection: "एक संग्रह बनाएं",
    create_collection_desc: "अपने संग्रह की संरचना मैन्युअल रूप से परिभाषित करें",
    read_the_docs: "दस्तावेज़ीकरण पढ़ें",
    read_the_docs_desc: "जानें कि Rebase का अधिकतम उपयोग कैसे करें",
    explore_docs: "दस्तावेज़ीकरण देखें",
    want_to_customize_with_code: "क्या आप कोड से Rebase को कस्टमाइज़ करना चाहते हैं?",
    to_scaffold_a_local_project: "एक स्थानीय प्रोजेक्ट बनाने के लिए",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "सत्यापन",
    unique: "अद्वितीय",
    required_message: "आवश्यक संदेश",
    required_tooltip: "यदि यह मान सेट नहीं है तो आप इस एंटिटी को सहेज नहीं पाएंगे",
    unique_tooltip: "एक ही मान वाली एक से अधिक एंटिटी नहीं हो सकतीं",
    lowercase: "लोअरकेस",
    uppercase: "अपरकेस",
    trim: "ट्रिम",
    exact_length: "सटीक लंबाई",
    min_length: "न्यूनतम लंबाई",
    max_length: "अधिकतम लंबाई",
    matches_regex: "रेजेक्स से मेल खाता है",
    not_valid_regexp: "वैध रेगुलर एक्सप्रेशन नहीं है",
    regex_helper: "उदा. /^\\d+$/ केवल अंकों के लिए",
    min_value: "न्यूनतम मान",
    max_value: "अधिकतम मान",
    less_than: "से कम",
    more_than: "से अधिक",
    positive_value: "सकारात्मक मान",
    negative_value: "नकारात्मक मान",
    integer_value: "पूर्णांक मान",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "अमान्य रेगुलर एक्सप्रेशन",
    must_specify_target_collection: "आपको फ़ील्ड के लिए एक लक्ष्य संग्रह निर्दिष्ट करना होगा",
    need_specify_repeat_field: "आपको एक दोहराव फ़ील्ड निर्दिष्ट करना होगा",
    need_specify_block_properties: "आपको इस ब्लॉक के गुण निर्दिष्ट करने होंगे",
    incomplete_condition: "अपूर्ण शर्त - कृपया एक फ़ील्ड चुनें",
    field_name: "फ़ील्ड का नाम",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "कानबन कॉलम प्रॉपर्टी",
    select_a_property: "एक प्रॉपर्टी चुनें",
    kanban_property_not_found: "प्रॉपर्टी \"{{property}}\" मौजूद नहीं है या एनम स्ट्रिंग प्रॉपर्टी नहीं है। कृपया एक वैध प्रॉपर्टी चुनें या चयन साफ़ करें।",
    no_enum_string_properties: "कोई एनम स्ट्रिंग प्रॉपर्टी नहीं मिली। कानबन दृश्य का उपयोग करने के लिए enumValues के साथ एक स्ट्रिंग प्रॉपर्टी जोड़ें।",
    kanban_column_description: "एंटिटीज़ को कॉलम में समूहित करने के लिए एनम मानों वाली एक स्ट्रिंग प्रॉपर्टी चुनें",
    create_property: "+ \"{{property}}\" प्रॉपर्टी बनाएं",
    order_property: "क्रम प्रॉपर्टी",
    order_property_not_found: "प्रॉपर्टी \"{{property}}\" मौजूद नहीं है या एक संख्या प्रॉपर्टी नहीं है। कृपया एक वैध प्रॉपर्टी चुनें या चयन साफ़ करें।",
    no_number_properties: "कोई संख्या प्रॉपर्टी नहीं मिली। क्रम सक्षम करने के लिए एक संख्या प्रॉपर्टी जोड़ें।",
    order_property_description: "आइटम का क्रम बनाए रखने के लिए एक संख्या प्रॉपर्टी चुनें",
    display_settings: "प्रदर्शन सेटिंग्स",
    default_row_size: "डिफ़ॉल्ट पंक्ति आकार",
    side_dialog_width: "साइड डायलॉग चौड़ाई",
    side_dialog_width_description: "वैकल्पिक रूप से एंटिटी साइड डायलॉग की चौड़ाई (पिक्सेल में) परिभाषित करें। डिफ़ॉल्ट 768px है",
    inline_editing_enabled: "डेटा को सीधे टेबल दृश्य में संपादित किया जा सकता है",
    inline_editing_disabled: "डेटा को केवल फ़ॉर्म दृश्य में संपादित किया जा सकता है",
    inline_editing_description: "फ़ॉर्म दृश्य खोले बिना सीधे टेबल दृश्य में डेटा संपादन की अनुमति दें।",
    include_json_view: "JSON दृश्य शामिल करें",
    no_json_view: "JSON दृश्य शामिल न करें",
    json_view_description: "दस्तावेज़ का JSON प्रतिनिधित्व शामिल करें।",
    not_found_suffix: "नहीं मिला",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "पाठ",
    editor_text_description: "बस सादे पाठ के साथ टाइप करना शुरू करें।",
    editor_heading_1: "शीर्षक 1",
    editor_heading_1_description: "बड़ा अनुभाग शीर्षक।",
    editor_heading_2: "शीर्षक 2",
    editor_heading_2_description: "मध्यम अनुभाग शीर्षक।",
    editor_heading_3: "शीर्षक 3",
    editor_heading_3_description: "छोटा अनुभाग शीर्षक।",
    editor_todo_list: "टू-डू सूची",
    editor_todo_list_description: "टू-डू सूची के साथ कार्यों को ट्रैक करें।",
    editor_bullet_list: "बुलेट सूची",
    editor_bullet_list_description: "एक सरल बुलेट सूची बनाएं।",
    editor_numbered_list: "क्रमांकित सूची",
    editor_numbered_list_description: "नंबरिंग के साथ एक सूची बनाएं।",
    editor_quote: "उद्धरण",
    editor_quote_description: "एक उद्धरण कैप्चर करें।",
    editor_code: "कोड",
    editor_code_description: "एक कोड स्निपेट कैप्चर करें।",
    editor_image: "छवि",
    editor_image_description: "अपने कंप्यूटर से एक छवि अपलोड करें।",
    editor_multiple: "एकाधिक",
    editor_link: "लिंक",
    editor_save: "सहेजें",
    editor_cancel: "रद्द करें",
    editor_remove_link: "लिंक हटाएं",
    editor_paste_or_type_link: "लिंक पेस्ट करें या टाइप करें",
    editor_open_in_new_window: "नई विंडो में खोलें",
    editor_bold: "बोल्ड",
    editor_italic: "इटैलिक",
    editor_underline: "अंडरलाइन",
    editor_strikethrough: "स्ट्राइकथ्रू",
    editor_autocomplete: "स्वतः पूर्ण",
    editor_autocomplete_description: "संदर्भ के आधार पर पाठ जोड़ें।",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "पाठ खोज सक्षम करें",
    text_search_local_not_recommended: "बड़ी संग्रहों के लिए स्थानीय पाठ खोज की अनुशंसा नहीं की जाती है।",
    text_search_local_fetch_warning: "ध्यान दें कि स्थानीय पाठ खोज सक्षम करने के लिए आपके संग्रह से सभी दस्तावेज़ प्राप्त करने और उन्हें ब्राउज़र में संग्रहीत करने की आवश्यकता होगी। बड़ी संग्रहों के लिए यह अक्षम हो सकता है और अतिरिक्त लागत भी लग सकती है।",
    text_search_external_suggestion: "बड़ी संग्रहों के लिए, Algolia या Elastic Search जैसे बाहरी खोज इंजन का उपयोग करने और अपनी कॉन्फ़िगरेशन में एक खोज प्रतिनिधि निर्दिष्ट करने की सलाह दी जाती है।",
    text_search_local_description: "स्थानीय पाठ खोज आपके संग्रह में पाठ खोज सक्षम करने का सबसे सरल तरीका है। यह ब्राउज़र में संग्रह के सभी दस्तावेज़ लोड करता है और खोज स्थानीय रूप से करता है। छोटी संग्रहों के लिए यह अनुशंसित विकल्प है।",
    text_search_own_implementation: "आपने अपना स्वयं का पाठ खोज नियंत्रक लागू किया है। आप अपने संग्रह के लिए पाठ खोज सक्षम कर सकते हैं।",
    text_search_enable_for_collection: "इस संग्रह के लिए सक्षम करें",
    text_search_enable_for_project: "प्रोजेक्ट के लिए सक्षम करें",
    text_search_enabled_snackbar: "स्थानीय पाठ खोज सक्षम की गई",

    settings_heading: "सेटिंग्स",
    settings_project_name: "परियोजना का नाम",
    settings_default_language: "डिफ़ॉल्ट भाषा",
    settings_default_language_caption: "इस परियोजना के लिए आधार भाषा चुनें। उपयोगकर्ता अपनी व्यक्तिगत सेटिंग्स में इस प्राथमिकता को बदल सकते हैं।",
    settings_enable_local_text_search: "स्थानीय पाठ खोज सक्षम करें",
    settings_local_text_search_caption: "सभी संग्रहों के लिए स्थानीय पाठ खोज सक्षम करें। इससे आप Rebase खोज पट्टी का उपयोग करके अपने संग्रहों में पाठ फ़ील्ड खोज सकेंगे। ध्यान दें कि इस सुविधा के कारण अधिक पठन हो सकते हैं, क्योंकि यह आपके संग्रहों के सभी पाठ फ़ील्ड को अनुक्रमित करेगी।",
    settings_doc_history_all_collections: "सभी संग्रहों के लिए दस्तावेज़ इतिहास सक्षम",
    settings_doc_history_caption: "सक्षम होने पर, सभी संग्रहों में डिफ़ॉल्ट रूप से इतिहास सक्षम होगा। आप प्रत्येक संग्रह में इस सेटिंग को बदल सकते हैं। इतिहास प्रत्येक दस्तावेज़ की __history उपसंग्रह में सहेजा जाएगा।",
    settings_theme: "थीम",
    settings_primary_color: "प्राथमिक रंग",
    settings_secondary_color: "द्वितीयक रंग",
    settings_sample_theme_components: "नमूना थीम घटक",
    settings_drag_drop_logo: "अपना लोगो यहां खींचें और छोड़ें",
    settings_security_rules: "सुरक्षा नियम",
    settings_security_rules_description: "Rebase डेटा तक पहुंच प्रतिबंधित करने के लिए Firebase सुरक्षा नियमों का उपयोग करता है। Rebase के माध्यम से नया उपयोगकर्ता बनाते समय, कस्टम दावा rebaseUser क्लाइंट प्रोजेक्ट में उपयोगकर्ता में जोड़ा जाता है। निम्नलिखित सुरक्षा नियम जोड़कर, आप सुनिश्चित करते हैं कि Rebase उपयोगकर्ता Rebase के माध्यम से डेटा तक पहुंच सकें।",
    settings_security_rules_add_domain: "कृपया अपने प्रदाता के अनुमत डोमेन में {{domain}} डोमेन जोड़ना याद रखें",
    settings_security_rules_caption: "ये नियम डेटा तक पहुंच को केवल Rebase उपयोगकर्ताओं तक सीमित करते हैं, लेकिन डेटाबेस स्तर पर अनुमतियों को लागू नहीं करते। अनुमतियां फ्रंटएंड में लागू होती हैं, जो अधिकांश परियोजनाओं के लिए ठीक काम करती हैं। यदि आपको डेटाबेस स्तर पर अनुमतियां लागू करने की आवश्यकता है, तो आप इन सुरक्षा नियमों को संशोधित कर सकते हैं। उपयोगकर्ता को सौंपी गई भूमिकाएं Firebase प्रमाणीकरण टोकन में कस्टम दावों के रूप में सेट की जाती हैं, इसलिए आप उन्हें अपने सुरक्षा नियमों में उपयोग कर सकते हैं।",

    // ─── Studio: SQL Editor ─────────────────────────────────────
    studio_sql_executing_query: "क्वेरी चल रही है...",
    studio_sql_query_error: "क्वेरी त्रुटि",
    studio_sql_run_query_placeholder: "परिणाम देखने के लिए एक क्वेरी चलाएँ",
    studio_sql_visual_execution_plan: "विज़ुअल निष्पादन योजना",
    studio_sql_success: "SUCCESS",
    studio_sql_no_results: "क्वेरी सफलतापूर्वक चली, लेकिन कोई परिणाम नहीं मिला।",
    studio_sql_rows: "Rows:",
    studio_sql_time: "Time:",
    studio_sql_copy_markdown: "Markdown के रूप में कॉपी करें",
    studio_sql_export_json: "JSON निर्यात करें",
    studio_sql_export_csv: "CSV निर्यात करें",
    studio_sql_format_sql: "SQL फ़ॉर्मैट करें",
    studio_sql_explain: "Explain",
    studio_sql_limit_1000: "Limit 1000",
    studio_sql_remove_from_favorites: "पसंदीदा से हटाएँ",
    studio_sql_add_to_favorites: "पसंदीदा में जोड़ें",
    studio_sql_save: "Save",
    studio_sql_run: "Run",
    studio_sql_database: "Database",
    studio_sql_role: "Role",
    studio_sql_admin: "(Admin)",
    studio_sql_select_db: "डेटाबेस चुनें",
    studio_sql_query_results: "क्वेरी परिणाम",
    studio_sql_save_snippet: "SQL स्निपेट सहेजें",
    studio_sql_snippet_name: "स्निपेट का नाम",
    studio_sql_snippet_name_placeholder: "उदा., सभी उपयोगकर्ता प्राप्त करें",
    studio_sql_snippet_saved_local: "यह आपके स्थानीय स्टोरेज में सहेजा जाएगा।",
    studio_sql_cancel: "Cancel",
    studio_sql_dangerous_operation: "खतरनाक संक्रिया मिली",
    studio_sql_dangerous_operation_body: "जो क्वेरी आप चलाने वाले हैं उसमें संभावित रूप से विनाशकारी संक्रियाएँ हैं (DELETE, DROP, TRUNCATE, या WHERE के बिना UPDATE)। क्या आप वाकई आगे बढ़ना चाहते हैं?",
    studio_sql_snippet_saved: "स्निपेट \"{{name}}\" सहेजा गया।",
    studio_sql_markdown_copied: "परिणाम Markdown के रूप में कॉपी हो गए!",
    studio_sql_markdown_copy_failed: "Markdown क्लिपबोर्ड पर कॉपी नहीं हो सका।",
    studio_sql_row_updated: "पंक्ति सफलतापूर्वक अपडेट हुई।",
    studio_sql_cannot_edit_missing_query: "पंक्तियाँ संपादित नहीं की जा सकतीं: अंतर्निहित क्वेरी अनुपलब्ध है।",
    studio_sql_cannot_resolve_table: "तालिका/प्राथमिक कुंजी निर्धारित नहीं हो सकी",
    studio_sql_missing_pk: "पंक्ति में प्राथमिक कुंजी स्तंभ अनुपलब्ध हैं: {{columns}}। सुरक्षित रूप से अपडेट नहीं किया जा सकता।",
    studio_sql_update_failed: "अपडेट विफल: {{message}}",
    studio_sql_execution_not_supported: "वर्तमान डेटा स्रोत SQL निष्पादन का समर्थन नहीं करता।",
    studio_sql_error_executing: "क्वेरी चलाते समय एक त्रुटि हुई।",
    studio_sql_error_explaining: "क्वेरी का विश्लेषण करते समय एक त्रुटि हुई।",
    studio_sql_save_first_to_favorite: "पसंदीदा में जोड़ने से पहले स्निपेट सहेजें।",
    studio_sql_collections_label: "Collections:",
    studio_sql_admin_collections_tooltip: "Tables in this query that are mapped as admin collections",
    studio_sql_edit_entity: "Edit {{name}} #{{id}}",
    studio_sql_sql_not_supported: "यह डेटा स्रोत SQL निष्पादन का समर्थन नहीं करता",
    studio_sql_fetch_error: "कनेक्शन विकल्प प्राप्त नहीं हो सके: {{message}}",
    studio_sql_unexpected_format: "अप्रत्याशित डेटा प्रारूप: {{type}}",
    studio_sql_no_tables: "इस डेटाबेस में कोई तालिका नहीं मिली।",
    studio_sql_schema_fetch_error: "स्कीमा प्राप्त नहीं हो सका: {{message}}",

    // ─── Studio: SQL Editor Sidebar ──────────────────────────────
    studio_sql_sidebar_snippets: "Snippets",
    studio_sql_sidebar_history: "History",
    studio_sql_sidebar_schema: "Schema",
    studio_sql_sidebar_no_snippets: "कोई सहेजा गया स्निपेट नहीं",
    studio_sql_sidebar_save_snippet_hint: "किसी क्वेरी को यहाँ देखने के लिए उसे सहेजें।",
    studio_sql_sidebar_no_history: "कोई इतिहास नहीं",
    studio_sql_sidebar_history_hint: "चलाई गई क्वेरीज़ यहाँ दिखाई देंगी।",
    studio_sql_sidebar_delete_snippet: "स्निपेट हटाएँ",
    studio_sql_close_tab: "यह क्वेरी टैब बंद करें",
    studio_sql_new_tab: "नया क्वेरी टैब",

    // ─── Studio: Schema Browser ──────────────────────────────────
    studio_schema_tables: "Tables",
    studio_schema_loading: "स्कीमा लोड हो रहा है...",
    studio_schema_no_tables: "कोई तालिका नहीं मिली",
    studio_schema_retry: "Retry",
    studio_schema_primary_key: "प्राथमिक कुंजी",
    studio_schema_select_all: "SELECT * FROM",
    studio_schema_insert_into: "INSERT INTO",
    studio_schema_update: "UPDATE",
    studio_schema_delete_from: "DELETE FROM",
    studio_schema_columns: "{{count}} स्तंभ",

    // ─── Studio: RLS Editor ──────────────────────────────────────
    studio_rls_title: "पंक्ति-स्तरीय सुरक्षा",
    studio_rls_description: "अपनी तालिकाओं के लिए RLS नीतियाँ प्रबंधित करें",
    studio_rls_enabled: "RLS सक्षम",
    studio_rls_disabled: "RLS निष्क्रिय",
    studio_rls_no_rls: "RLS नहीं",
    studio_rls_enable_rls: "RLS सक्षम करें",
    studio_rls_disable_rls: "RLS निष्क्रिय करें",
    studio_rls_create_policy: "नीति बनाएँ",
    studio_rls_policies: "Policies",
    studio_rls_no_policies: "कोई नीति परिभाषित नहीं",
    studio_rls_no_policies_desc: "इस तालिका में कोई RLS नीति नहीं है। सभी पंक्तियों तक पहुँच RLS की स्थिति पर निर्भर करती है।",
    studio_rls_add_first_policy: "अपनी पहली नीति जोड़ें",
    studio_rls_force_rls: "RLS बाध्य करें",
    studio_rls_force_rls_desc: "सक्षम होने पर RLS नीतियाँ तालिका के स्वामी पर भी लागू होती हैं।",
    studio_rls_enable_force_rls: "बाध्य RLS सक्षम करें",
    studio_rls_disable_force_rls: "बाध्य RLS निष्क्रिय करें",
    studio_rls_edit: "Edit",
    studio_rls_delete: "Delete",
    studio_rls_confirm_delete_title: "नीति हटाएँ",
    studio_rls_confirm_delete_body: "क्या आप वाकई यह नीति हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
    studio_rls_confirm_enable_title: "पंक्ति-स्तरीय सुरक्षा सक्षम करें",
    studio_rls_confirm_enable_body: "RLS सक्षम करने पर इस तालिका की पंक्तियों तक पहुँच आपकी नीतियों के अनुसार सीमित हो जाएगी। सुनिश्चित करें कि उपयुक्त नीतियाँ मौजूद हैं।",
    studio_rls_confirm_disable_title: "पंक्ति-स्तरीय सुरक्षा निष्क्रिय करें",
    studio_rls_confirm_disable_body: "RLS निष्क्रिय करने पर सभी पंक्तियाँ सभी भूमिकाओं के लिए सुलभ हो जाएँगी। क्या आप वाकई जारी रखना चाहते हैं?",
    studio_rls_select_table: "एक तालिका चुनें",
    studio_rls_no_tables: "कोई तालिका उपलब्ध नहीं",
    studio_rls_error: "नीतियाँ लोड करने में त्रुटि",
    studio_rls_retry: "Retry",
    studio_rls_loading: "नीतियाँ लोड हो रही हैं...",

    // ─── Studio: Policy Editor ───────────────────────────────────
    studio_policy_edit: "नीति संपादित करें",
    studio_policy_create: "नई नीति बनाएँ",
    studio_policy_defining_rules: "इसके लिए पहुँच नियम परिभाषित किए जा रहे हैं",
    studio_policy_cancel: "Cancel",
    studio_policy_save: "नीति सहेजें",
    studio_policy_template: "टेम्पलेट से शुरू करें (वैकल्पिक)",
    studio_policy_select_template: "एक टेम्पलेट चुनें...",
    studio_policy_name: "नीति का नाम",
    studio_policy_name_placeholder: "अपनी नीति को एक स्पष्ट नाम दें",
    studio_policy_behavior: "नीति का व्यवहार",
    studio_policy_permissive: "Permissive",
    studio_policy_permissive_desc: "\"OR\" से संयोजित",
    studio_policy_restrictive: "Restrictive",
    studio_policy_restrictive_desc: "\"AND\" से संयोजित",
    studio_policy_command: "नीति की कमांड",
    studio_policy_target_roles: "लक्षित भूमिकाएँ",
    studio_policy_roles_placeholder: "भूमिकाएँ चुनें (डिफ़ॉल्ट: public)",
    studio_policy_using_expr: "USING एक्सप्रेशन",
    studio_policy_using_expr_desc: "मौजूदा पंक्तियों पर लागू (SELECT, UPDATE, DELETE)",
    studio_policy_check_expr: "WITH CHECK एक्सप्रेशन",
    studio_policy_check_expr_desc: "नई या संशोधित पंक्तियों पर लागू (INSERT, UPDATE)",
    studio_policy_help_title: "पंक्ति-स्तरीय सुरक्षा (RLS) मार्गदर्शिका",
    studio_policy_help_intro: "पंक्ति-स्तरीय सुरक्षा (RLS) से आप तय करते हैं कि कोई उपयोगकर्ता अपनी प्रमाणीकरण स्थिति या भूमिकाओं के आधार पर कौन-सी पंक्तियाँ देख या बदल सकता है।",
    studio_policy_help_step1_title: "1. एक टेम्पलेट चुनें",
    studio_policy_help_step1_desc: "यदि आप RLS में नए हैं, तो सबसे आसान तरीका ड्रॉपडाउन से एक पूर्वनिर्धारित टेम्पलेट चुनना है। यह \"उपयोगकर्ता अपनी ही पंक्तियाँ अपडेट कर सकते हैं\" जैसे सामान्य मामलों के लिए नीति स्वतः कॉन्फ़िगर कर देगा।",
    studio_policy_help_step2_title: "2. लक्षित भूमिकाएँ",
    studio_policy_help_step2_desc: "चुनें कि नीति किन उपयोगकर्ताओं पर लागू होगी:",
    studio_policy_help_role_public: "सभी पर लागू (लॉग इन हों या न हों)।",
    studio_policy_help_role_authenticated: "केवल लॉग इन किए हुए उपयोगकर्ताओं पर लागू।",
    studio_policy_help_role_anon: "केवल उन उपयोगकर्ताओं पर लागू जो लॉग इन नहीं हैं।",
    studio_policy_help_step3_title: "3. USING एक्सप्रेशन",
    studio_policy_help_step3_desc: "एक SQL शर्त जो सत्य होने पर ही मौजूदा पंक्तियाँ दिखती या बदली जा सकती हैं (SELECT, UPDATE, DELETE)।",
    studio_policy_help_step3_example: "सुनिश्चित करता है कि उपयोगकर्ता केवल वही पंक्तियाँ देखें जिनके वे स्वामी हैं।",
    studio_policy_help_step4_title: "4. WITH CHECK एक्सप्रेशन",
    studio_policy_help_step4_desc: "एक SQL शर्त जो सत्य होने पर ही नई या संशोधित पंक्तियाँ सहेजी जाती हैं (INSERT, UPDATE)।",
    studio_policy_help_step4_example: "आम तौर पर USING एक्सप्रेशन जैसा ही, जब उपयोगकर्ता केवल अपना ही डेटा जोड़ या संपादित कर सकते हों।",
    studio_policy_help_auth_vars_title: "Rebase प्रमाणीकरण वेरिएबल",
    studio_policy_help_auth_vars_desc: "Rebase ऐसे नेटिव हेल्पर फ़ंक्शन देता है जिन्हें आप अपने एक्सप्रेशन में उपयोग कर सकते हैं:",
    studio_policy_help_auth_uid: "वर्तमान उपयोगकर्ता की ID को टेक्स्ट के रूप में लौटाता है। उदाहरण:",
    studio_policy_help_auth_jwt: "पूरा JWT पेलोड JSONB के रूप में लौटाता है, ताकि आप कस्टम क्लेम जाँच सकें। उदाहरण:",
    studio_policy_help_auth_roles: "उपयोगकर्ता की भूमिका-ID को अल्पविराम से अलग स्ट्रिंग के रूप में लौटाता है। इसके साथ सर्वोत्तम:",
    studio_policy_help_docs_cta: "Postgres नीतियों के बारे में और जानने के लिए आधिकारिक दस्तावेज़ देखें।",
    studio_policy_help_read_docs: "दस्तावेज़ पढ़ें",
    studio_policy_help_got_it: "समझ गए!",

    // ─── Studio: UI Actions ──────────────────────────────────────
    studio_add_kanban_column: "स्तंभ जोड़ें",
    studio_add_kanban_column_title: "Kanban स्तंभ जोड़ें",
    studio_add_kanban_column_name: "स्तंभ का नाम",
    studio_add_kanban_column_name_placeholder: "नए स्तंभ का नाम",
    studio_add_kanban_column_add: "Add",
    studio_add_kanban_column_cancel: "Cancel",
    studio_collection_view_sql: "SQL संपादक",
    studio_collection_view_admin: "व्यवस्थापक दृश्य",
    studio_editor_collection_tooltip: "संग्रह का स्कीमा संपादित करें",
    studio_editor_collection_no_permission: "आपको इस संग्रह को संपादित करने की अनुमति नहीं है",
    studio_editor_collection_start_tooltip: "पथ कॉपी करें या स्कीमा संपादित करें",
    studio_editor_collection_start_no_permission: "आपको इस संग्रह में बदलाव करने की अनुमति नहीं है",
    studio_editor_collection_start_copied: "Copied!",
    studio_editor_entity_tooltip: "इकाई का स्कीमा संपादित करें",
    studio_editor_entity_no_permission: "आपको इस इकाई को संपादित करने की अनुमति नहीं है",
    studio_home_edit_collection: "संग्रह संपादित करें",
    studio_home_delete_collection: "संग्रह हटाएँ",
    studio_home_confirm_delete_title: "संग्रह हटाएँ?",
    studio_home_confirm_delete_body: "क्या आप वाकई \"{{name}}\" संग्रह हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
    studio_kanban_setup: "Kanban सेटअप",
    studio_missing_reference: "अनुपलब्ध संदर्भ: {{path}}",
    studio_missing_reference_create: "Create",
    studio_new_collection: "नया संग्रह",
    studio_new_collection_card: "नया संग्रह",
    studio_new_collection_no_permission: "आपको संग्रह बनाने की अनुमति नहीं है",
    studio_property_add_column: "नई प्रॉपर्टी जोड़ें",
    studio_property_add_column_no_permission: "आपको नई प्रॉपर्टी जोड़ने की अनुमति नहीं है",
    studio_add_kanban_column_desc: "\"{{property}}\" प्रॉपर्टी में एक नया विकल्प जोड़ता है। इससे Kanban बोर्ड में एक नया स्तंभ बनेगा।",
    studio_add_kanban_column_adding: "Adding...",
    studio_collection_view_edit: "Edit",
    studio_editor_collection_disabled: "संग्रह संपादन निष्क्रिय है",
    studio_editor_collection_edit: "संग्रह संपादित करें",
    studio_editor_entity_save_first: "स्कीमा बदलने से पहले आपको दस्तावेज़ सहेजना होगा",
    studio_editor_entity_edit_schema: "इस फ़ॉर्म का स्कीमा संपादित करें",
    studio_editor_collection_start_save_filter: "डिफ़ॉल्ट फ़िल्टर और क्रम सहेजें",
    studio_editor_collection_start_clear_filter: "डिफ़ॉल्ट फ़िल्टर और क्रम हटाएँ",
    studio_editor_collection_start_reset_filter: "डिफ़ॉल्ट फ़िल्टर और क्रम पर लौटें",
    studio_editor_collection_start_saved: "डिफ़ॉल्ट कॉन्फ़िगरेशन सहेजा गया",
    studio_home_duplicate_collection: "Duplicate",
    studio_home_delete: "Delete",
    studio_home_confirm_delete_no_data: "इससे कोई डेटा नहीं हटेगा, केवल व्यवस्थापक पैनल का संग्रह हटेगा",
    studio_home_collection_deleted: "संग्रह हटा दिया गया",
    studio_kanban_configure: "Kanban कॉन्फ़िगर करें",
    studio_missing_reference_error: "इस पथ के लिए कोई संग्रह नहीं: {{path}}",
    studio_new_collection_add: "नया संग्रह जोड़ें",

    // ─── Property field labels ──────────────────────────────────
    db_column_type: "डेटाबेस कॉलम प्रकार",
    primary_key_unique_id: "प्राथमिक कुंजी / अद्वितीय ID",
    spread_children_as_columns: "बच्चों को कॉलम के रूप में फैलाएं",
    mode: "मोड",
    timezone: "समय क्षेत्र",
    target_collection: "लक्ष्य संग्रह",

    // ─── Storage property ───────────────────────────────────────
    storage_file_name: "फ़ाइल का नाम",
    storage_path: "संग्रहण पथ",
    storage_max_size: "अधिकतम आकार (बाइट्स में)",
    storage_resize_mode: "आकार बदलने का मोड",
    storage_output_format: "आउटपुट प्रारूप",
    storage_max_width: "अधिकतम चौड़ाई (px)",
    storage_max_height: "अधिकतम ऊंचाई (px)",
    storage_quality: "गुणवत्ता (0-100)",
    storage_file_upload_config: "फ़ाइल अपलोड कॉन्फ़िगरेशन",
    storage_image_resize_config: "इमेज आकार बदलने का कॉन्फ़िगरेशन",
    storage_all_file_types: "सभी फ़ाइल प्रकार अनुमत",
    storage_allowed_file_types: "अनुमत फ़ाइल प्रकार",
    storage_include_bucket_url: "सहेजे गए मान में बकेट URL (s3://...) शामिल करें",
    storage_save_url: "संग्रहण पथ के बजाय URL सहेजें",

    // ─── DateTime property ──────────────────────────────────────
    datetime_automatic_value: "स्वचालित मान",

    // ─── Markdown property ──────────────────────────────────────
    markdown_paste_behavior: "पेस्ट व्यवहार",

    // ─── Entity identity bar and inspector ──────────────────────
    entity_saved: "सहेजा गया",
    more_actions: "अधिक क्रियाएँ",
    record_history: "इतिहास",
    inspect_record: "रिकॉर्ड जाँचें",
    inspect: "जाँचें",
    close_inspector: "इंस्पेक्टर बंद करें",
    open_in_live_site: "लाइव साइट में खोलें",

    // ─── Revision history ───────────────────────────────────────
    history_revert: "इस संस्करण पर लौटें",
    history_revert_title: "डेटा को इस संस्करण पर लौटाएँ?",
    history_reverted: "चयनित संस्करण पर लौटा दिया गया",
    history_revert_error: "रिकॉर्ड लौटाने में त्रुटि",
    history_revert_dirty: "लौटाने से पहले अपने बदलाव सहेजें या रद्द करें",
    history_empty: "कोई इतिहास उपलब्ध नहीं",
    history_empty_description: "रिकॉर्ड सहेजने पर एक नया संस्करण बनता है और इतिहास में रखा जाता है।",
    history_new_entity: "इतिहास केवल मौजूदा रिकॉर्ड के लिए उपलब्ध है",
    history_no_more: "और इतिहास नहीं",

    // ─── Studio: tools, groups and empty states ─────────────────
    // The admin's own three groups, read by `useNavigationGroupLabel` the same
    // way as the Studio ones below — the group *name* is an identifier the
    // ordering and the icons key off, and only the heading is translated.
    studio_group_views: "दृश्य",
    studio_group_admin: "व्यवस्थापन",
    studio_group_settings: "सेटिंग्स",
    studio_group_database: "डेटाबेस",
    studio_group_compute: "कंप्यूट",
    studio_group_storage: "स्टोरेज",
    studio_group_api: "API",
    studio_group_access_control: "एक्सेस नियंत्रण",
    studio_tool_sql: "SQL कंसोल",
    studio_tool_sql_description: "SQL क्वेरी चलाएँ",
    studio_tool_js: "JS कंसोल",
    studio_tool_js_description: "JavaScript चलाएँ",
    studio_tool_rls: "RLS नीतियाँ",
    studio_tool_rls_description: "पंक्ति-स्तरीय सुरक्षा",
    studio_tool_storage: "स्टोरेज",
    studio_tool_storage_description: "स्टोरेज फ़ाइलें प्रबंधित करें",
    studio_tool_cron: "क्रॉन जॉब",
    studio_tool_cron_description: "निर्धारित कार्य प्रबंधित करें",
    studio_tool_schema_visualizer: "स्कीमा विज़ुअलाइज़र",
    studio_tool_schema_visualizer_description: "इंटरैक्टिव डेटाबेस ERD",
    studio_tool_branches: "ब्रांच",
    studio_tool_branches_description: "डेटाबेस ब्रांच बनाएँ और प्रबंधित करें",
    studio_tool_backups: "बैकअप",
    studio_tool_backups_description: "डेटाबेस बैकअप डाउनलोड करें",
    studio_tool_api: "API एक्सप्लोरर",
    studio_tool_api_description: "इंटरैक्टिव API दस्तावेज़ और परीक्षण",
    studio_tool_logs: "लॉग एक्सप्लोरर",
    studio_tool_logs_description: "रीयल-टाइम सिस्टम और क्वेरी लॉग",
    studio_tool_api_keys: "API कुंजियाँ",
    studio_tool_api_keys_description: "स्कोप वाली API कुंजियाँ बनाएँ और प्रबंधित करें",
    studio_backups_denied_title: "आप इस प्रोजेक्ट के बैकअप सूचीबद्ध नहीं कर सकते",
    studio_backups_denied_hint: "प्रोजेक्ट में कोई गड़बड़ी नहीं है। बैकअप सूचीबद्ध करने के लिए एडमिन कनेक्शन चाहिए, और साइन-इन किए गए खाते को मना कर दिया गया।",
    studio_backups_read_failed: "इस प्रोजेक्ट के बैकअप नहीं पढ़े जा सके",
    studio_backups_downloading: "डाउनलोड हो रहा है…",
    studio_backups_roles_file: "रोल फ़ाइल",
    studio_backups_roles_file_hint: "इस बैकअप के साथ सहेजी गई .globals.sql। यह वे डेटाबेस रोल फिर से बनाती है जिनका ज़िक्र डंप की अनुमतियाँ और पंक्ति-स्तरीय सुरक्षा करती हैं, और `rebase db restore` इसे .dump के पास से पढ़ता है, इसलिए दोनों फ़ाइलें साथ रखें।",
    studio_backups_no_roles_file: "कोई रोल फ़ाइल नहीं",
    studio_backups_no_roles_file_hint: "इस बैकअप के साथ कोई .globals.sql सहेजी नहीं गई। इसे किसी नए Postgres में रिस्टोर करने पर यह पहली ऐसी अनुमति पर रुक जाता है जो किसी ऐसे डेटाबेस रोल को दी गई हो जो वहाँ मौजूद नहीं है।",
    studio_cron_denied_title: "आप इस प्रोजेक्ट के क्रॉन जॉब सूचीबद्ध नहीं कर सकते",
    studio_cron_denied_hint: "प्रोजेक्ट में कोई गड़बड़ी नहीं है। क्रॉन API केवल एडमिन के लिए है, और साइन-इन किए गए खाते को मना कर दिया गया।",
    studio_cron_read_failed: "इस प्रोजेक्ट के क्रॉन जॉब नहीं पढ़े जा सके",
    studio_api_keys_denied_title: "आप इस प्रोजेक्ट की API कुंजियाँ सूचीबद्ध नहीं कर सकते",
    studio_api_keys_denied_hint: "प्रोजेक्ट में कोई गड़बड़ी नहीं है। API कुंजियाँ प्रबंधित करना एडमिन कार्य है, और साइन-इन किए गए खाते को मना कर दिया गया।",
    studio_api_keys_read_failed: "इस प्रोजेक्ट की API कुंजियाँ नहीं पढ़ी जा सकीं",
    studio_api_keys_empty_title: "अभी तक कोई API कुंजी नहीं",
    studio_api_keys_empty_hint: "सेवाओं के बीच प्रमाणीकरण सक्षम करने के लिए एक कुंजी बनाएँ",
    studio_api_keys_revoke: "निरस्त करें",
    studio_api_keys_select_hint: "विवरण देखने के लिए एक API कुंजी चुनें",
    studio_api_keys_permissions: "अनुमतियाँ",
    studio_api_keys_no_permissions: "कोई अनुमति कॉन्फ़िगर नहीं की गई",
    studio_api_keys_revoke_confirmation: "निरस्तीकरण की पुष्टि",
    studio_api_keys_name_label: "नाम:",
    studio_api_keys_access_label: "पहुँच:",
    studio_api_keys_admin_granted: "व्यवस्थापक भूमिका प्रदान की गई",
    studio_api_keys_admin_granted_hint: "व्यवस्थापक रूट और default_admin नीतियाँ",
    studio_api_keys_done: "हो गया",
    studio_api_keys_status_active: "सक्रिय",
    studio_api_keys_status_expired: "समाप्त",
    studio_api_keys_status_revoked: "निरस्त",
    studio_api_keys_stat_status: "स्थिति",
    studio_api_keys_stat_last_used: "अंतिम उपयोग",
    studio_api_keys_stat_expires: "समाप्ति",
    studio_api_keys_never: "कभी नहीं",
    studio_api_keys_role_service: "सेवा",
    studio_api_keys_stat_rate_limit: "दर सीमा",
    studio_api_keys_rate_limit_default: "डिफ़ॉल्ट (1000/15 मिनट)",
    studio_api_keys_stat_created_by: "निर्माता",
    studio_api_keys_copy_failed: "कॉपी नहीं हो सका",
    studio_branches_denied_title: "आप इस प्रोजेक्ट की ब्रांच सूचीबद्ध नहीं कर सकते",
    studio_branches_denied_hint: "प्रोजेक्ट में कोई गड़बड़ी नहीं है। ब्रांचिंग एडमिन कनेक्शन पर चलती है, और साइन-इन किए गए खाते को मना कर दिया गया।",
    studio_branches_read_failed: "इस प्रोजेक्ट की ब्रांच नहीं पढ़ी जा सकीं",
    studio_schema_no_collections: "कोई कलेक्शन घोषित नहीं",
    studio_schema_no_collections_body: "अभी बनाने के लिए कुछ नहीं है। config/collections/ में एक कलेक्शन जोड़ें, या यहाँ जोड़ने के लिए “कलेक्शन संपादित करें” खोलें।",
    studio_schema_introspect_hint: "जिस डेटाबेस में पहले से टेबल हैं, वहाँ rebase schema introspect आपके लिए कलेक्शन फ़ाइलें लिख देता है।",


    // ─── Studio: RLS editor confirmations ───────────────────────
    studio_rls_enable_confirm_title: "पंक्ति-स्तरीय सुरक्षा सक्षम करें?",
    studio_rls_enable_confirm_body: "जब तक कोई नीति अनुमति न दे, {{table}} की कोई पंक्ति पढ़ी नहीं जा सकेगी। Postgres डिफ़ॉल्ट रूप से मना करता है।",
    studio_rls_disable_confirm_title: "पंक्ति-स्तरीय सुरक्षा अक्षम करें?",
    studio_rls_disable_confirm_body: "{{table}} पर सभी नीतियाँ लागू होना बंद हो जाएँगी। जो भी टेबल तक पहुँच सकता है, हर पंक्ति पढ़ और लिख सकेगा।",
    studio_rls_drop_policy_title: "इस नीति को हटाएँ?",
    studio_rls_drop_policy_body: "{{policy}} को डेटाबेस में {{table}} से हटा दिया जाएगा। आपके कोड में कुछ नहीं लिखा जाता, इसलिए डिप्लॉय इसे वापस ला सकता है।",
    studio_rls_unapplied: "लागू नहीं",
    studio_rls_unapplied_tooltip: "आपके कोड में घोषित, डेटाबेस में अभी नहीं। बदलाव की योजना बनाकर लागू करने के लिए इसे यहाँ सहेजें, या `rebase db push` चलाएँ।",


    // ─── Studio: empty states that name a remedy ────────────────
    studio_branches_unavailable_title: "डेटाबेस ब्रांचिंग उपलब्ध नहीं है",
    studio_branches_unavailable_body: "ब्रांचिंग के लिए एडमिन कनेक्शन वाला Postgres बैकएंड चाहिए। बैकएंड के एनवायरनमेंट में ADMIN_CONNECTION_STRING सेट करें।",
    studio_backups_not_configured_title: "बैकअप कॉन्फ़िगर नहीं हैं",
    studio_backups_not_configured_body: "BACKUP_DESTINATION को किसी लोकल पाथ या s3:// अथवा gs:// URL पर सेट करें, फिर `rebase db backup` या निर्धारित क्रॉन से बैकअप बनाएँ।",
    studio_cron_empty_title: "कोई क्रॉन जॉब पंजीकृत नहीं",
    studio_cron_empty_body: "backend/crons/ में एक फ़ाइल जोड़ें जो CronJobDefinition को डिफ़ॉल्ट एक्सपोर्ट करे।",
    studio_read_the_docs: "दस्तावेज़ पढ़ें"
};
